/**
 * @generated SignedSource<<d6569e76784b00a70842858cebc555a1>>
 * @relayHash 4f287ff1b78627d989dcb59dbc47c082
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/458.0.0-2024-04-17T07:05:02.830Z/RenderDesignerContactEmailMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RenderDesignerContactEmailInput = {
  captchaToken?: string | null;
  clientMutationId?: string | null;
  message?: string | null;
  recipientEmails: ReadonlyArray<string | null>;
  senderEmail: string;
  senderName: string;
};
export type RenderDesignerContactEmailMutation$variables = {
  input: RenderDesignerContactEmailInput;
};
export type RenderDesignerContactEmailMutation$data = {
  readonly renderDesignerContactEmail: {
    readonly clientMutationId: string | null;
  } | null;
};
export type RenderDesignerContactEmailMutation = {
  response: RenderDesignerContactEmailMutation$data;
  variables: RenderDesignerContactEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RenderDesignerContactEmailPayload",
    "kind": "LinkedField",
    "name": "renderDesignerContactEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RenderDesignerContactEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RenderDesignerContactEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-misc/458.0.0-2024-04-17T07:05:02.830Z/RenderDesignerContactEmailMutation",
    "metadata": {},
    "name": "RenderDesignerContactEmailMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "17db93465f406d18214842de27dade5f";

export default node;
